<ngb-toast *ngFor="let toast of toastService.toasts; trackBy:trackByIndex;" class="toast" [autohide]="true"
    [delay]="5000" (hidden)="toastService.remove(toast)" (click)="on_Click(toast)">
    <div class="left-aligned" [innerHtml]="toast.text"></div>
</ngb-toast>
